export function getEdgeFunctionsBaseUrl() {
  const supabaseUrl = process.env.VUE_APP_SUPABASE_URL;
  if (!supabaseUrl) {
    return '';
  }

  return `${String(supabaseUrl).replace(/\/$/, '')}/functions/v1`;
}

export function buildEdgeFunctionUrl(functionName, params = {}) {
  const baseUrl = getEdgeFunctionsBaseUrl();
  const url = new URL(`${baseUrl}/${functionName}`);

  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && typeof value !== 'undefined' && value !== '') {
      url.searchParams.set(key, String(value));
    }
  });

  return url.toString();
}

export function buildEdgeFunctionHeaders({ accessToken, headers = {} } = {}) {
  const nextHeaders = {
    ...headers,
  };
  const anonKey = process.env.VUE_APP_SUPABASE_ANON_KEY;

  if (anonKey && !nextHeaders.apikey) {
    nextHeaders.apikey = anonKey;
  }

  if (accessToken && !nextHeaders.Authorization) {
    nextHeaders.Authorization = `Bearer ${accessToken}`;
  }

  return nextHeaders;
}